import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MuiButton, { buttonClasses } from '@mui/material/Button';
import MuiButtonBase from '@mui/material/ButtonBase';
import * as React from 'react';
import { Box } from '../box';
import { useMergeRefs, useOverflow } from '../hooks';
import { Skeleton } from '../skeleton';
import { styled } from '../styled';
import { Tooltip } from '../tooltip';
import { firstLetterUppercase } from '../typography';
import { makeEnum, withVersion } from '../utils';
export { MuiButtonBase as ButtonBase };
const variants = [
    'contained',
    'outlined',
    'text'
];
const sizes = ['small', 'medium', 'large'];
export const ButtonVariant = makeEnum(...variants);
export const ButtonSize = makeEnum(...sizes);
const StyledMuiButton = styled(MuiButton)((props) => {
    const overflowProps = {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        display: 'inline-block'
    };
    return {
        height: props.height,
        textTransform: 'none',
        pointerEvents: props.$skeleton ? 'none' : undefined,
        minWidth: 0,
        ...(!props.startIcon && !props.endIcon && props.$childrenIsString
            ? overflowProps
            : {}),
        [`.${buttonClasses.loadingIndicator}`]: {
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        },
        ...firstLetterUppercase
    };
});
const ButtonImpl = React.forwardRef(({ skeleton, ...props }, ref) => {
    const innerRef = useMergeRefs(ref);
    const { textOverflow } = useOverflow(innerRef);
    return (_jsx(Tooltip, { title: props.children, bypass: !textOverflow, children: _jsxs(StyledMuiButton, { ref: innerRef, "data-role": "button", disableElevation: true, "$childrenIsString": typeof props.children === 'string', "$skeleton": skeleton, ...props, children: [props.children, skeleton && (_jsx(Box, { component: "span", bgcolor: "background.paper", position: "absolute", width: "100%", height: "100%", left: 0, top: 0, children: _jsx(Skeleton, { width: "100%", height: "100%" }) }))] }) }));
});
export const Button = withVersion(ButtonImpl, '1.0.0');
export * from './icon-button';
export const buttonStyle = {
    MuiButton: {
        styleOverrides: {
            sizeSmall: ({ theme }) => ({
                fontSize: theme.palette.components?.button?.small?.fontSize,
                fontWeight: theme.palette.components?.button?.small?.fontWeight
            }),
            sizeMedium: ({ theme }) => ({
                fontSize: theme.palette.components?.button?.medium?.fontSize,
                fontWeight: theme.palette.components?.button?.medium?.fontWeight
            }),
            sizeLarge: ({ theme }) => ({
                fontSize: theme.palette.components?.button?.large?.fontSize,
                fontWeight: theme.palette.components?.button?.large?.fontWeight
            })
        }
    }
};
